import React from 'react';
import { MORE } from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import PrivacyPolicy from '../presentational/PrivacyPolicy';
import useTranslate from 'suits-me-npm/languages/useTranslate';

const PrivacyPolicyContainer = () => {
    const translate = useTranslate('privacyPolicy');
    return (
        <PageContainer className="more-privacy-policy-container">
            <SectionTitle
                title={translate('breadcrumbText')}
                backRoute={MORE}
            />
            <PrivacyPolicy />
        </PageContainer>
    );
};

export default PrivacyPolicyContainer;
